import styled from 'styled-components';

export const StyledActiveButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  .ant-form-item {
    width: 50px;
  }

  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const StyledLabelContainer = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  margin-bottom: 16px;
  gap: 4px;
  :hover {
    cursor: pointer;
  }
`;
